/**
 * Backend config
 *
 * @module config/backend
 */
define('config/backend',[],function() {
    'use strict';

    return {
    };
});
